"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectAppointmentRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.RejectAppointmentRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    appointmentId: (0, superstruct_1.string)(),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    statusChangeReason: (0, superstruct_1.optional)((0, superstruct_1.enums)(['incomplete', 'missingStaff', 'overbooking', 'technicalIssues'])),
});
//# sourceMappingURL=RejectAppointmentRequest.js.map